import React, { useState } from 'react';
import { Shield, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const isPrivacy = type === 'privacy';
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-207">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-208">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 bg-offwhite sticky top-0 z-10" data-id="element-209">
          <h2 className="text-xl font-serif font-bold text-navy" data-id="element-210">
            {isPrivacy ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-navy/5 hover:bg-navy/10 flex items-center justify-center text-navy/60 hover:text-navy transition-colors" aria-label="Cerrar" data-id="element-211">
            <X size={20} data-id="element-212" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-72px)] text-navy/80 text-sm leading-relaxed space-y-5" data-id="element-213">
          {isPrivacy ? <>
              <p className="text-xs text-gray-400 uppercase tracking-wider font-bold" data-id="element-214">
                Última actualización: Marzo 2026
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-215">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-216">
                Recopilamos información personal que usted nos proporciona
                voluntariamente al realizar una compra, como su nombre y
                dirección de correo electrónico. No recopilamos información de
                menores de edad directamente.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-217">
                2. Uso de la Información
              </h3>
              <p data-id="element-218">
                Utilizamos su información personal exclusivamente para procesar
                su compra, enviarle el producto digital adquirido y comunicarnos
                con usted sobre su pedido. No compartimos, vendemos ni
                alquilamos su información personal a terceros.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-219">
                3. Protección de Datos
              </h3>
              <p data-id="element-220">
                Implementamos medidas de seguridad técnicas y organizativas para
                proteger su información personal contra acceso no autorizado,
                alteración, divulgación o destrucción.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-221">4. Cookies</h3>
              <p data-id="element-222">
                Nuestro sitio web puede utilizar cookies para mejorar la
                experiencia del usuario y analizar el tráfico del sitio. Usted
                puede configurar su navegador para rechazar cookies, aunque esto
                podría afectar la funcionalidad del sitio.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-223">5. Sus Derechos</h3>
              <p data-id="element-224">
                Usted tiene derecho a acceder, rectificar o eliminar sus datos
                personales en cualquier momento. Para ejercer estos derechos,
                puede comunicarse con nosotros a través de los canales
                disponibles en nuestro sitio.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-225">
                6. Cambios en esta Política
              </h3>
              <p data-id="element-226">
                Nos reservamos el derecho de actualizar esta política de
                privacidad en cualquier momento. Los cambios serán publicados en
                esta página con la fecha de la última actualización.
              </p>
            </> : <>
              <p className="text-xs text-gray-400 uppercase tracking-wider font-bold" data-id="element-227">
                Última actualización: Marzo 2026
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-228">
                1. Aceptación de los Términos
              </h3>
              <p data-id="element-229">
                Al acceder y utilizar este sitio web y adquirir nuestros
                productos digitales, usted acepta estar sujeto a estos términos
                y condiciones. Si no está de acuerdo con alguno de estos
                términos, le rogamos que no utilice nuestro sitio.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-230">
                2. Producto Digital
              </h3>
              <p data-id="element-231">
                "Escudo de Confianza" es un producto digital educativo en
                formato PDF. El contenido es de carácter informativo y no
                sustituye el asesoramiento profesional de psicólogos, terapeutas
                o autoridades competentes.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-232">
                3. Entrega del Producto
              </h3>
              <p data-id="element-233">
                Una vez completada la compra, recibirá acceso inmediato al
                producto digital mediante descarga. Debido a la naturaleza
                digital del producto, la entrega es instantánea.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-234">
                4. Propiedad Intelectual
              </h3>
              <p data-id="element-235">
                Todo el contenido del ebook, incluyendo textos, gráficos,
                plantillas y metodologías, está protegido por derechos de autor.
                Queda prohibida su reproducción, distribución o reventa sin
                autorización expresa.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-236">
                5. Limitación de Responsabilidad
              </h3>
              <p data-id="element-237">
                Los resultados pueden variar según cada caso individual. No
                garantizamos resultados específicos. En casos de violencia
                física o situaciones de emergencia, se debe contactar a las
                autoridades competentes de inmediato.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-238">
                6. Política de Reembolso
              </h3>
              <p data-id="element-239">
                Debido a la naturaleza digital del producto, no se aceptan
                devoluciones una vez descargado el contenido. Si experimenta
                problemas técnicos con la descarga, nos comprometemos a
                resolverlos.
              </p>

              <h3 className="text-lg font-bold text-navy" data-id="element-240">7. Ley Aplicable</h3>
              <p data-id="element-241">
                Estos términos se regirán e interpretarán de acuerdo con las
                leyes aplicables en la jurisdicción correspondiente.
              </p>
            </>}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-400 py-12 border-t border-white/5" data-id="element-242">
        <div className="container mx-auto px-4 md:px-6 max-w-6xl flex flex-col items-center text-center" data-id="element-243">
          <div className="flex items-center gap-2 text-white mb-6 opacity-50" data-id="element-244">
            <Shield size={24} data-id="element-245" />
            <span className="font-serif font-bold text-xl tracking-wide" data-id="element-246">
              ESCUDO DE CONFIANZA
            </span>
          </div>

          <p className="mb-6 max-w-md text-sm leading-relaxed" data-id="element-247">
            Escudo de Confianza es un recurso educativo diseñado para empoderar
            a las familias. El contenido de esta guía no sustituye el
            asesoramiento profesional de psicólogos o autoridades competentes.
          </p>

          <div className="flex items-center gap-6 mb-6" data-id="element-248">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-400 hover:text-amber transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-amber" data-id="element-249">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-250">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-400 hover:text-amber transition-colors underline underline-offset-4 decoration-gray-600 hover:decoration-amber" data-id="element-251">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm" data-id="element-252">
            &copy; {currentYear} Escudo de Confianza. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-253">
        {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-254" />}
      </AnimatePresence>
    </>;
}